






































import BaseComponent from "@/components/base-component.vue";
import * as resize from "@/subjects/resize";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import UiHeader from "./header.vue";

@Component({
  components: {
    UiHeader
  }
})
export default class UiFilterContainer extends BaseComponent {
  @Prop({ default: "Titulo" })
  public title: string;

  @Prop({default: false})
  xsOrSmAsMobile: boolean;

  @Prop({default: false})
  showRefresh: boolean;

  refreshDisabled = false;

  public showFilterMenu: boolean = false;
  public expand = 0;

  xsSmScreen: boolean = resize.isXsOrSmSizeScreen();
  xsScreen: boolean = resize.isXsSizeScreen();

  mounted() {
    resize.windowSizeChanged$.subscribe((val) => {
      this.xsScreen = resize.isXsSizeScreen();
      this.xsSmScreen = resize.isXsOrSmSizeScreen();
    });
  }

  close() {
    this.showFilterMenu = false; 
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  refresh() {
    this.$emit('refresh');
    this.refreshDisabled = true;
    setTimeout(() => {
      this.refreshDisabled = false;
    }, 10000);
  }
}
